<template>
    <sidebar @close="$emit('close')">
        <template v-slot:title>
            Federal
        </template>
        <slot>
            <minimum-wage-sidebar-widget
                jurisdiction="fed"
                :fed="fed"
                @updated="$emit('updated')"
            />

            <filing-status-sidebar-widget
                jurisdiction="fed"
                :fed="fed"
                @updated="$emit('updated')"
            />

            <tax-withholding-config-sidebar-widget
                jurisdiction="fed"
                :fed="fed"
                @updated="$emit('updated')"
            />
        </slot>
    </sidebar>
</template>

<script>
import MinimumWageSidebarWidget from './MinimumWageSidebarWidget'
import Sidebar from '@/components/Sidebar'
import FilingStatusSidebarWidget from './FilingStatusSidebarWidget'
import InfoWidget from '@/components/InfoWidget'
import TaxWithholdingConfigSidebarWidget from './TaxWithholdingConfigSidebarWidget'

export default {
    components: {Sidebar, InfoWidget, MinimumWageSidebarWidget, FilingStatusSidebarWidget, TaxWithholdingConfigSidebarWidget, },
    props: ['fed', ],
}
</script>
